import { useFeatures, type WorkspaceFeatures } from "@expert/features";
import { NotificationCenter } from "@expert/solve-tools";
import { Group, useMatches } from "@mantine/core";
import { env } from "@/config";
import { AgentStatus, FeedbackButton, Profile } from "@/header";
import { usePartnerFeatureConfigured } from "@/partner/usePartnerConfig";
import { useFeatureFlag } from "@/shared-utils";
import EvlConnectionStatus from "../evl/EvlConnectionStatus";

export function HeaderControls() {
    const { feedback, feedbackType } = usePartnerFeatureConfigured();
    const { data: isEvlConnectionStatusEnabled = false } = useFeatureFlag("EWP-isEvlConnectionStatusEnabled");
    const {
        features: { isOutageAlertInfoEnabled },
    } = useFeatures<WorkspaceFeatures>();

    const buttonGroupGap = useMatches({
        base: "xs",
        md: "sm",
        lg: "md",
    });

    return (
        <Group wrap="nowrap" align="center" pr="lg" gap="lg">
            <Group gap="0" id="header-status-group" wrap="nowrap" align="center">
                {env.channel !== "chat" && isEvlConnectionStatusEnabled && <EvlConnectionStatus />}
            </Group>
            <Group gap={buttonGroupGap} id="header-controls-group" wrap="nowrap" align="center">
                {isOutageAlertInfoEnabled && <NotificationCenter />}
                {feedback && feedbackType && <FeedbackButton feedbackType={feedbackType} />}
                <AgentStatus />
                <Profile isProdMode={env.isProdMode} commitHash={env.commitHash} />
            </Group>
        </Group>
    );
}
